<mat-expansion-panel expanded="false">
  <mat-expansion-panel-header>
    <mat-panel-title>
      Recherche de personnes à mettre en copie du message envoyé au demandeur
    </mat-panel-title>
  </mat-expansion-panel-header>
  <div class="container">
    <app-search-ldap class="ldap-search"
                     [mode]="'light'"
                     [ldapDisplayProperty]="'cn,mail'"
                     [removeDiatrics]="true"
                     [placeHolder]="'Rechercher une personne dans l\'annuaire LDAP puis la sélectionner pour l\'ajouter aux destinataires...'"
                     [toolTip]="'Taper les 3 premiers caractères pour une recherche dans l\'annuaire LDAP puis sélectionner pour l\'ajouter aux destinataires...'"
                     [scope]="true"
                     [title]="false"
                     [scopesToDisplay]="['employee', 'faculty', 'researcher', 'student']"
                     (ldapUserSelected)="onSelectIndividuLdap($event)">
    </app-search-ldap>
    <ng-container *ngIf="groupListsSelect.length > 0">
      <div class="separator">OU</div>
      <mat-form-field appearance="fill" class="lists-select">
        <mat-label>Sélectionner une personne dans vos listes prédéfinies</mat-label>
        <mat-select
          placeholder="Sélectionner une personne dans vos listes prédéfinies"
          matTooltip="Sélectionner une personne dans une de vos listes prédéfinies"
          (valueChange)="onSelectListRequesters($event)">
          <mat-optgroup *ngFor="let group of groupListsSelect" label="{{group.listName}}">
            <mat-option *ngFor="let person of group.requesters"
                        [value]="person"
                        [matTooltip]="toolTipSelectedPersons(person)">
              {{person.displayName}} <span *ngIf="person.informations">({{person.informations|truncate:30}})</span>
            </mat-option>
          </mat-optgroup>
        </mat-select>
      </mat-form-field>
    </ng-container>
  </div>
  <div *ngIf="listGuests.length > 0">
    <div>
      <span>{{ personsText }}</span>
      <mat-chip-listbox>
        <mat-chip-option *ngFor="let guest of listGuests" removable>
              <span style="display: flex; align-items: center">
                <span [matTooltip]="guest.email">{{guest.displayName}}</span>
                <span class="spacer"></span>
                <button matChipRemove (click)="deleteGuestChip(guest)"
                        [matTooltip]="'Enlever cette personne'" data-cy="button-remove-tos-chip" aria-label="enlever cette personne">
                    <mat-icon class="mat-16">close</mat-icon>
                </button>
              </span>
        </mat-chip-option>
      </mat-chip-listbox>
    </div>
  </div>
</mat-expansion-panel>
